<ng-template #action>
  <ng-container class="headline-action-button">
    <button
      [matMenuTriggerFor]="menu"
      mat-button
      class="action-button"
      aria-label="Open menu"
      [disabled]="isActionsDisabled"
    >
      <span class="mat-button-wrapper"><i class="material-icons">more_horiz</i></span>
    </button>
    <mat-menu #menu="matMenu">
      <button class="mat-menu-item-btn" mat-menu-item (click)="removeTemplates('bulkRemove')">
        <span>Remove</span>
      </button>
    </mat-menu>
  </ng-container>
</ng-template>
<div *ngIf="table?.data" class="table">
  <viavi-table
    [tableConfigurations]="table"
    [isActionEnabled]="hasReadWriteRole && isCheckBoxEnabled"
    (sendRowAction)="onRowActionClick($event)"
    [template]="action"
    [resetCheckbox]="resetCheckbox"
  >
  </viavi-table>
</div>
